import { render, staticRenderFns } from "./userother.vue?vue&type=template&id=4ccf7e70&scoped=true&"
import script from "./userother.vue?vue&type=script&lang=js&"
export * from "./userother.vue?vue&type=script&lang=js&"
import style0 from "./userother.vue?vue&type=style&index=0&id=4ccf7e70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccf7e70",
  null
  
)

export default component.exports